import { Button, Checkbox, Form, Input, Modal } from 'antd';
import './App.css';
import { useNavigate } from 'react-router-dom';
import { Message } from './components';
import { useState } from 'react';
import { addEnterprise, getEnterpriseInfo } from './Functions';
import { useForm } from 'antd/es/form/Form';



function Register() {
  const navigate = useNavigate();
  const [openMessage, setOpenMessage] = useState(false);
  const [message, setMessage]         = useState('');
  const [form] = useForm()

  
  async function register (values) {
    try{
      const { businessName, password, passwordConfirm , email } = values;
      if( password != passwordConfirm){
        setMessage('Le password non corrispondono');
        setOpenMessage(true);
        return;
      }
      const add = await addEnterprise(businessName, businessName, email, password, 'administrator' );
      if( add ){
        setMessage('Azienda creata');
        form.resetFields();
        setOpenMessage(true);
        return;
      }
      setMessage('Errore nella creazione');
      setOpenMessage(true);
    }catch( err ){
      console.log(err);
    }
  }
  


  return (
    <div className="center bg-color-primary all-viewport">
      {
         Message( message, openMessage, ()=> setOpenMessage(false))
      }
      
      <Form
        form={form}
        name="basic"
        style={{ maxWidth: 600,}}
        onFinish={register}
        onFinishFailed={() => {}}
        autoComplete="off"
        className=''
      >
        <div onClick={()=> console.log( getEnterpriseInfo() ) } className='center text-style' style={{ marginBottom:'10px'}}> Registrazione </div>
        <Form.Item
          name="businessName"
          rules={[{ required: true, message: 'Inserire ragione sociale' }]}
        >
          <Input className='input-style' placeholder='Ragione sociale'/>
        </Form.Item>

        <Form.Item
          name="email"
          rules={[{ required: true, message: 'Inserire email' }]}
        >
          <Input className='input-style' placeholder='Email'/>
        </Form.Item>

        <Form.Item
          name="password"
          rules={[{ required: true, message: 'Inserire Password!' }]}
        >
          <Input.Password className='input-style'  placeholder='Password'/>
        </Form.Item>

        <Form.Item
          name="passwordConfirm"
          rules={[{ required: true, message: 'Inserire Password!' }]}
        >
          <Input.Password  className='input-style'  placeholder='Password'/>
        </Form.Item>
        
        <div className='center' style={{flexDirection:'column'}}>
          <Button
          className=' input-style color-one'
            //style={{width: '100%'}} 
            type="primary" 
            htmlType="submit">
            Registrati </Button>
            <div style={{height:'20px'}}></div>

            <Button
            onClick={()=> navigate('/')}
            className='input-style color-two'
            type="primary" 
            htmlType="">
            Torna al log in </Button>
        </div>
      </Form>

    </div>
  );
}

export default Register;
